
// ===== Data =====
const BUILDING_PROFILES = {
  "Office":               { kwh_ft2: 16, shares: { HVAC: 0.30, Lighting: 0.28, Plug: 0.35, Other: 0.07 }, ref_hours: 60 },
  "Retail (Standalone)":  { kwh_ft2: 14, shares: { HVAC: 0.32, Lighting: 0.38, Plug: 0.22, Other: 0.08 }, ref_hours: 60 },
  "Strip Shopping Mall":  { kwh_ft2: 16, shares: { HVAC: 0.30, Lighting: 0.40, Plug: 0.22, Other: 0.08 }, ref_hours: 60 },
  "Enclosed Mall":        { kwh_ft2: 20, shares: { HVAC: 0.34, Lighting: 0.36, Plug: 0.22, Other: 0.08 }, ref_hours: 60 },
  "Warehouse/Storage":    { kwh_ft2:  6, shares: { HVAC: 0.20, Lighting: 0.55, Plug: 0.20, Other: 0.05 }, ref_hours: 40 },
  "Education (K-12)":     { kwh_ft2: 11, shares: { HVAC: 0.34, Lighting: 0.32, Plug: 0.28, Other: 0.06 }, ref_hours: 50 },
  "Higher Education":     { kwh_ft2: 14, shares: { HVAC: 0.34, Lighting: 0.30, Plug: 0.30, Other: 0.06 }, ref_hours: 70 },
  "Healthcare (Outpatient)": { kwh_ft2: 28, shares: { HVAC: 0.30, Lighting: 0.25, Plug: 0.37, Other: 0.08 }, ref_hours: 80 },
  "Hospital/Inpatient":   { kwh_ft2: 30, shares: { HVAC: 0.33, Lighting: 0.22, Plug: 0.37, Other: 0.08 }, ref_hours: 168 },
  "Lodging/Hotel":        { kwh_ft2: 15, shares: { HVAC: 0.36, Lighting: 0.26, Plug: 0.30, Other: 0.08 }, ref_hours: 168 },
  "Food Service (Restaurant)": { kwh_ft2: 55, shares: { HVAC: 0.18, Lighting: 0.18, Plug: 0.56, Other: 0.08 }, ref_hours: 84 },
  "Food Sales (Grocery)": { kwh_ft2: 50, shares: { HVAC: 0.22, Lighting: 0.18, Plug: 0.52, Other: 0.08 }, ref_hours: 112 },
  "Public Assembly":      { kwh_ft2: 10, shares: { HVAC: 0.32, Lighting: 0.42, Plug: 0.20, Other: 0.06 }, ref_hours: 40 },
  "Religious Worship":    { kwh_ft2:  6, shares: { HVAC: 0.25, Lighting: 0.55, Plug: 0.15, Other: 0.05 }, ref_hours: 20 },
  "Service (Other)":      { kwh_ft2: 13, shares: { HVAC: 0.30, Lighting: 0.36, Plug: 0.26, Other: 0.08 }, ref_hours: 50 },
  "Laboratory":           { kwh_ft2: 35, shares: { HVAC: 0.32, Lighting: 0.18, Plug: 0.42, Other: 0.08 }, ref_hours: 90 },
  "Data/Server Center (Office-integrated)": { kwh_ft2: 80, shares: { HVAC: 0.28, Lighting: 0.06, Plug: 0.60, Other: 0.06 }, ref_hours: 168 },
  "Other/Mixed":          { kwh_ft2: 12, shares: { HVAC: 0.30, Lighting: 0.36, Plug: 0.26, Other: 0.08 }, ref_hours: 60 }
};
const STATES = ["AL","AK","AZ","AR","CA","CO","CT","DC","DE","FL","GA","HI","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VA","VT","WA","WI","WV","WY"];
const STATE_RENEWABLE_PCT = {
  "CA":0.36,"TX":0.28,"IA":0.64,"SD":0.83,"KS":0.47,"OK":0.45,"WA":0.74,"OR":0.60,"ID":0.80,
  "VT":0.99,"NY":0.33,"MA":0.28,"FL":0.08,"VA":0.12,"NC":0.14,"SC":0.09,"GA":0.09,"AZ":0.12,
  "NM":0.36,"NV":0.35,"UT":0.13,"CO":0.32,"WY":0.20,"MT":0.45,"ND":0.38,"NE":0.30,"MN":0.31,
  "WI":0.12,"MI":0.12,"IL":0.14,"IN":0.09,"OH":0.06,"PA":0.08,"NJ":0.08,"CT":0.10,"RI":0.10,
  "ME":0.70,"NH":0.19,"MD":0.13,"DE":0.08,"DC":0.05,"KY":0.05,"WV":0.06,"LA":0.04,"MS":0.03,
  "AL":0.13,"AR":0.11,"MO":0.10,"TN":0.13,"HI":0.30
};

const PRICING = {
  500:  { HydroWind: 5.00, SolarWind: 7.00, AllSolar: 10.00 },
  1000: { HydroWind: 10.00, SolarWind: 14.00, AllSolar: 20.00 },
  2000: { HydroWind: 20.00, SolarWind: 28.00, AllSolar: 40.00 },
  3000: { HydroWind: 30.00, SolarWind: 42.00, AllSolar: 60.00 },
  4000: { HydroWind: 40.00, SolarWind: 56.00, AllSolar: 80.00 },
  5000: { HydroWind: 50.00, SolarWind: 70.00, AllSolar: 100.00 },
  6000: { HydroWind: 60.00, SolarWind: 84.00, AllSolar: 120.00 },
  7000: { HydroWind: 70.00, SolarWind: 98.00, AllSolar: 140.00 },
  8000: { HydroWind: 80.00, SolarWind: 112.00, AllSolar: 160.00 },
  9000: { HydroWind: 90.00, SolarWind: 126.00, AllSolar: 180.00 }
};

const CO2_LB_PER_KWH = 1.481; // U.S. National Average

// ===== Elements =====
const buildingSelect = document.getElementById('buildingType');
const stateSelect = document.getElementById('stateSelect');
const floorAreaEl = document.getElementById('floorArea');
const weeklyHoursEl = document.getElementById('weeklyHours');
const climateEl = document.getElementById('climate');

const equipKitchenEl = document.getElementById('equipKitchen');
const equipRefrigEl = document.getElementById('equipRefrig');
const equipServersEl = document.getElementById('equipServers');
const kitchenPctEl = document.getElementById('kitchenPct');
const kitchenPctValEl = document.getElementById('kitchenPctVal');
const refrigPctEl = document.getElementById('refrigPct');
const refrigPctValEl = document.getElementById('refrigPctVal');
const serverPctEl = document.getElementById('serverPct');
const serverPctValEl = document.getElementById('serverPctVal');
const hvacPctEl = document.getElementById('hvacPct');
const hvacPctValEl = document.getElementById('hvacPctVal');

const annualKWhEl = document.getElementById('annualKWh');
const monthlyKWhEl = document.getElementById('monthlyKWh');
const stateRenewablePctEl = document.getElementById('stateRenewablePct');
const stateRenewableNoteEl = document.getElementById('stateRenewableNote');
const annualNonRenKWhEl = document.getElementById('annualNonRenKWh');
const monthlyNonRenKWhEl = document.getElementById('monthlyNonRenKWh');
const annualCO2El = document.getElementById('annualCO2');
const annualCO2mtEl = document.getElementById('annualCO2mt');
const monthlyCO2NonRenEl = document.getElementById('monthlyCO2NonRen');
const monthlyCO2NonRenMtEl = document.getElementById('monthlyCO2NonRenMt');
const assumptionsEl = document.getElementById('assumptions');

const recPrimaryEl = document.getElementById('recPrimary');
const recPricingEl = document.getElementById('recPricing');

// Populate dropdowns
Object.keys(BUILDING_PROFILES).forEach(name => {
  const opt = document.createElement('option'); opt.value = name; opt.textContent = name; buildingSelect.appendChild(opt);
});
STATES.forEach(code => {
  const opt = document.createElement('option'); opt.value = code; opt.textContent = code; stateSelect.appendChild(opt);
});
buildingSelect.value = "Office";
stateSelect.value = "VA";

// Chart init
let supportChartRef = null;
function renderSupportChart(renBefore, nonRenBefore) {
  const ctx = document.getElementById('supportChart').getContext('2d');
  if (supportChartRef) supportChartRef.destroy();
  const total = (renBefore||0)+(nonRenBefore||0);
  const renPct = total>0 ? Math.round((renBefore/total)*100) : 0;
  const nonPct = 100 - renPct;
  supportChartRef = new Chart(ctx, {type:'bar',data:{labels:['Renewable Support','Non-Renewable Energy Support'],datasets:[{data:[renBefore,nonRenBefore],backgroundColor:['#10b981','#6b7280']} ]},options:{plugins:{legend:{display:false},tooltip:{callbacks:{label:(c)=> c.raw.toLocaleString()+' kWh/yr'}}},scales:{y:{beginAtZero:true}}}});
  const rEl=document.getElementById('renPctNum'); if(rEl) rEl.textContent = `${renPct}%`;
  const nEl=document.getElementById('nonPctNum'); if(nEl) nEl.textContent = `${nonPct}%`;
}

// Pricing UI
function updatePrice(amt){
  const p = PRICING[amt];
  recPricingEl.innerHTML = p ? (`
    <div class="plan-grid">
      <div class="plan-card hydrowind"><div class="plan-title">HydroWind</div><div class="plan-price">$${p.HydroWind.toFixed(2)}</div><div class="plan-unit">per mo.</div></div>
      <div class="plan-card solarwind"><div class="plan-title">SolarWind</div><div class="plan-price">$${p.SolarWind.toFixed(2)}</div><div class="plan-unit">per mo.</div></div>
      <div class="plan-card allsolar"><div class="plan-title">AllSolar</div><div class="plan-price">$${p.AllSolar.toFixed(2)}</div><div class="plan-unit">per mo.</div></div>
    </div>
  `) : '';
}

// Compute
function compute(){
  const b = BUILDING_PROFILES[buildingSelect.value] || BUILDING_PROFILES["Office"];
  const area = Math.max(0, Number(floorAreaEl.value)||0);
  const hours = Math.max(0, Number(weeklyHoursEl.value)||0);
  const climate = (climateEl.value||'moderate').toLowerCase();
  const stateCode = stateSelect.value || 'VA';
  const renShare = (STATE_RENEWABLE_PCT[stateCode] != null) ? STATE_RENEWABLE_PCT[stateCode] : 0.2;

  const hvacShare = b.shares.HVAC;
  const cFactor = {cool:0.95, moderate:1.0, hot:1.08}[climate] || 1.0;
  const hvacPct = Math.max(0, Math.min(1, ((Number(hvacPctEl.value)||100)/100)));

  const baseIntensity = b.kwh_ft2 * ((hvacShare * cFactor * hvacPct) + (1 - hvacShare));
  const hoursFactor = hours>0 ? (hours / b.ref_hours) : 0;
  const intensityAdj = baseIntensity * hoursFactor;

  const kOn = !!equipKitchenEl.checked, rOn = !!equipRefrigEl.checked, sOn = !!equipServersEl.checked;
  const kPct = Math.max(0, Math.min(1, ((Number(kitchenPctEl.value)||0)/100)));
  const rPct = Math.max(0, Math.min(1, ((Number(refrigPctEl.value)||0)/100)));
  const sPct = Math.max(0, Math.min(1, ((Number(serverPctEl.value)||0)/100)));
  const adders = (kOn?20*kPct:0) + (rOn?15*rPct:0) + (sOn?25*sPct:0);

  const annualKWh = (intensityAdj + adders) * area;
  const monthlyKWh = annualKWh/12;

  const annualNonRen = annualKWh * (1 - renShare);
  const monthlyNonRen = monthlyKWh * (1 - renShare);

  const annualCO2_lbs = annualNonRen * CO2_LB_PER_KWH;
  const monthlyCO2_lbs = monthlyNonRen * CO2_LB_PER_KWH;

  // UI
  annualKWhEl.textContent = Math.round(annualKWh).toLocaleString() + " kWh";
  monthlyKWhEl.textContent = Math.round(monthlyKWh).toLocaleString() + " kWh";
  stateRenewablePctEl.textContent = (renShare*100).toFixed(0) + "%";
  stateRenewableNoteEl.innerHTML = stateCode + " renewable share. " +
    '<a href="https://www.epa.gov/egrid/summary-data" target="_blank" rel="noopener">Source: EPA eGRID Summary Data</a>';
  annualNonRenKWhEl.textContent = Math.round(annualNonRen).toLocaleString() + " kWh";
  monthlyNonRenKWhEl.textContent = Math.round(monthlyNonRen).toLocaleString() + " kWh";
  annualCO2El.textContent = Math.round(annualCO2_lbs).toLocaleString() + " lb CO₂";
  annualCO2mtEl.textContent = "≈ " + (annualCO2_lbs/2204.62).toFixed(1) + " metric tons / year";
  monthlyCO2NonRenEl.textContent = Math.round(monthlyCO2_lbs).toLocaleString() + " lb CO₂";
  monthlyCO2NonRenMtEl.textContent = "≈ " + (monthlyCO2_lbs/2204.62).toFixed(1) + " metric tons / month";
  assumptionsEl.textContent = `Profile=${buildingSelect.value}; Weather=${climate}; State=${stateCode}; Hours=${hours}/wk; Area=${area.toLocaleString()} ft²; KitchenArea=${kOn?Math.round(kPct*100):0}%; RefrigerationArea=${rOn?Math.round(rPct*100):0}%; ServerArea=${sOn?Math.round(sPct*100):0}%; Heated&Cooled=${Math.round(hvacPct*100)}%.`;

// Sustainable Choice (driven by NON-RENEWABLE monthly usage)
const target = Math.max(0, monthlyNonRen);
if (target <= 0) {
  recPrimaryEl.innerHTML = '<span class="muted">Your state’s grid mix is ~100% renewable on average; there is no non-renewable portion to cover.</span>';
  recPricingEl.innerHTML = '';
} else if (target > 9000) {
  recPrimaryEl.innerHTML = '<span class="muted">Non-renewable usage exceeds 9,000 kWh per month, please contact for a Custom Quote.</span>';
  recPricingEl.innerHTML = '';
} else {
  const options = [];
  if (target <= 500) {
    options.push(500);
  } else {
    const full = Math.min(9000, Math.ceil(target / 1000) * 1000);
    for (let t = full; t >= 1000; t -= 1000) options.push(t);
    options.push(500);
  }
  renderSC(options, 0, target);
}


  // Chart
  renderSupportChart(annualKWh*renShare, annualNonRen);
}

// Toggle slider visibility
function updateLoadSliderUI(){
  const kOn = equipKitchenEl.checked;
  const rOn = equipRefrigEl.checked;
  const sOn = equipServersEl.checked;
  const kRow = document.getElementById('kitchenRow');
  const rRow = document.getElementById('refrigRow');
  const sRow = document.getElementById('serverRow');
  kRow.classList.toggle('disabled', !kOn); kitchenPctEl.disabled = !kOn;
  rRow.classList.toggle('disabled', !rOn); refrigPctEl.disabled = !rOn;
  sRow.classList.toggle('disabled', !sOn); serverPctEl.disabled = !sOn;
}

// Events
document.getElementById('calcBtn').addEventListener('click', compute);
document.getElementById('resetBtn').addEventListener('click', ()=>{
  buildingSelect.value="Office"; stateSelect.value="VA";
  floorAreaEl.value=500; weeklyHoursEl.value=60; climateEl.value="moderate";
  equipKitchenEl.checked=false; equipRefrigEl.checked=false; equipServersEl.checked=false;
  kitchenPctEl.value=10; refrigPctEl.value=10; serverPctEl.value=5; hvacPctEl.value=100;
  kitchenPctValEl.textContent="10%"; refrigPctValEl.textContent="10%"; serverPctValEl.textContent="5%"; hvacPctValEl.textContent="100%";
  updateLoadSliderUI(); compute();
});

[equipKitchenEl,equipRefrigEl,equipServersEl].forEach(el=> el.addEventListener('change', ()=>{ updateLoadSliderUI(); compute(); }));
kitchenPctEl.addEventListener('input', ()=>{ kitchenPctValEl.textContent=`${kitchenPctEl.value}%`; compute(); });
refrigPctEl.addEventListener('input', ()=>{ refrigPctValEl.textContent=`${refrigPctEl.value}%`; compute(); });
serverPctEl.addEventListener('input', ()=>{ serverPctValEl.textContent=`${serverPctEl.value}%`; compute(); });
hvacPctEl.addEventListener('input', ()=>{ hvacPctValEl.textContent=`${hvacPctEl.value}%`; compute(); });
/* === Sustainable Choice slider UI (with ± and tick labels) === */
function renderSC(options, startIndex, targetKWh) {
  const idx = Math.max(0, Math.min(options.length - 1, startIndex || 0));
  const amt = options[idx];
  const pct = Math.min(100, Math.round((amt / targetKWh) * 100));

  recPrimaryEl.innerHTML = `
    <div class="rec-lead"><strong>${amt.toLocaleString()} KWh/mo.</strong> covers ${pct}% of non-renewable use</div>
    <div class="sc-control">
      <button type="button" class="sc-btn" id="scPrev" aria-label="Decrease">−</button>
      <input id="scSlider" type="range" min="0" max="${options.length - 1}" step="1" value="${idx}">
      <button type="button" class="sc-btn" id="scNext" aria-label="Increase">+</button>
    </div>
    <div class="sc-ticks" id="scTicks" style="grid-template-columns: repeat(${options.length}, minmax(0,1fr));">
      ${options.map((v,i)=> `<span class="tick ${i===idx?'active':''}" data-idx="${i}" role="button" tabindex="0">${v.toLocaleString()}</span>`).join('')}
    </div>
  `;

  // Price cards for the current amount
  updatePrice(amt);

  // Wire up controls
  const slider = document.getElementById('scSlider');
  const prev = document.getElementById('scPrev');
  const next = document.getElementById('scNext');
  const ticks = document.getElementById('scTicks');

  if (slider) {
    slider.style.touchAction = 'pan-y';
    slider.oninput = (e) => renderSC(options, Number(e.target.value), targetKWh);
  }
  if (prev) prev.onclick = () => renderSC(options, idx - 1, targetKWh);
  if (next) next.onclick = () => renderSC(options, idx + 1, targetKWh);
  if (ticks) {
    ticks.onclick = (e) => {
      const t = e.target.closest('[data-idx]');
      if (t) renderSC(options, Number(t.dataset.idx), targetKWh);
    };
    ticks.onkeydown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        const t = e.target.closest('[data-idx]');
        if (t) { e.preventDefault(); renderSC(options, Number(t.dataset.idx), targetKWh); }
      }
    };
  }
}

// Initial
updateLoadSliderUI();
compute();
